import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ContentElement, SliderOptions, SliderType } from '../../../models/sections-model';
import { trigger, transition, group, query, style, animate, keyframes, state } from '@angular/animations';


@Component({
  selector: 'kw-row-slider',
  templateUrl: './row-slider.component.html',
  styleUrls: ['./row-slider.component.scss'],
  animations:[
    trigger('sliderAnimation',[
      state('next',style({transform: '{{slidePosition}}'}),{params:{slidePosition:'translateX(0)'}}),
      state('previous',style({transform: '{{slidePosition}}'}),{params:{slidePosition:'translateX(0)'}}),
      transition('* => next',[
        animate('0.5s ease-out')
      ]),
      transition('previous => next',[
        animate('0.5s ease-out')
      ]),
      transition('next => next',[
        animate('0.5s ease-out')
      ]),
      transition('previous => previous',[
        animate('0.5s ease-out')
      ]),
    ])
  ]
})
export class RowSliderComponent implements OnInit,AfterViewInit {
  @Input() data:SliderOptions;
  @Input() edit:boolean;
  slides:any[];
  layout:string;
  numberOfElements:number;

  actualIndex = 0;
  selectedIndex = 0;

  itemsLength:number;

  layoutClass:string;

  autoStart = false;
  backingItems = ['1', '2', '3', '4', '5'];
  anchorSlide:HTMLElement;
  slideWidth:any;
  title:ContentElement;

  wrapperClass:string;

  sliderAnimation:string;

  slidePositionNumber = 0;

  slidePosition:string = "transform:translateX(0px)";

  scrollWidth:number;

  sliderType:string;


  @ViewChild('slides',{read:ElementRef}) slideEls:ElementRef<HTMLElement>

  constructor(private cdr:ChangeDetectorRef) { }

  ngOnInit(): void {
    console.log(this.data);
    this.sliderType = this.data.sliderType?this.data.sliderType:SliderType.ROW;
    this.slides = this.data.slides?this.data.slides:this.data["rowCells"];
    this.numberOfElements = this.data.numberOfElements?this.data.numberOfElements:4;
    this.layoutClass = this.setLayoutClass(this.numberOfElements);
    this.wrapperClass = this.data.wrapperClass?this.data.wrapperClass:"solid";
    this.itemsLength = this.slides.length;
    console.log(this.slides);
    this.layout = this.data.layout;
    console.log(this.layoutClass);
    this.title = this.data.title;
  }

  updateSelectedIndex(index){
    console.log(index)
    console.log({numberOfElements:this.numberOfElements})
    if(index > this.selectedIndex){
      this.sliderAnimation = "next",
      this.slidePositionNumber = this.slidePositionNumber-this.scrollWidth;
    }else{
      this.sliderAnimation = "previous";
      this.slidePositionNumber = this.slidePositionNumber+this.scrollWidth;
    }
    this.slidePosition = "translateX("+this.slidePositionNumber+"px)";
    this.selectedIndex = index;
    this.cdr.detectChanges()
  }

  setLayoutClass(numberOfElements:number){
    console.log(numberOfElements);
    let layoutClass:string;
    switch (numberOfElements) {
      case 3:
        layoutClass = "col-3";
        break;
      case 4:
        layoutClass = "col-4";
        break;
      case 6:
        layoutClass = "col-6";
        break;
      default:
        layoutClass = "col-6";
        break;
    }
    console.log(layoutClass);
    return layoutClass;
  }

  get items() {
    //console.log({selectedIndex:this.selectedIndex,actualIndex:this.actualIndex});
    //console.log(this.slides[this.actualIndex]);
    return this.slides;
    //return [this.slides[this.actualIndex]];
  }

  ngAfterViewInit():void{
    setTimeout(() => {
      if(this.slideEls != undefined){
        //Get the scroll width
        this.anchorSlide = <HTMLElement>this.slideEls.nativeElement.firstChild;
        this.slideWidth = this.anchorSlide.offsetWidth;
        let firstSibbling = <HTMLElement>this.anchorSlide.nextSibling;
        this.scrollWidth = firstSibbling.getBoundingClientRect().left - this.anchorSlide.getBoundingClientRect().left
        //Set content container position to relative
      }
    }, 1);
    
  }

}
